import { create } from 'apisauce'

import store from '../store'
import handleNetworkError from '../actions/network'
import { refreshUserToken } from '../actions/user'
import { getAPIEndpoint } from '../utils/apiConstants'
import { logout } from '../actions/application'

const baseURL = `${getAPIEndpoint()}/webtransporter`
const apiPrd = create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

const checkForToken = () => `bearer ${store.getState().user && store.getState().user.access_token}`

apiPrd.axiosInstance.interceptors.request.use(
  (config) => {
    const newConfig = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: checkForToken(),
        // FIX: for GET requests
        // more in: https://github.com/infinitered/apisauce/issues/120
        'Content-Type': 'application/json',
      },
    }
    return newConfig
  },
  (error) =>
    // Do something with request error
    Promise.reject(error)
)

// apiPrd.addResponseTransform((response) => {
//   console.log(JSON.stringify(response))
// })

apiPrd.axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    new Promise(() => {
      if (error.response) {
        const statusCode = error.response.status
        if (statusCode === 401) {
          // call to login
          return store.dispatch(logout())
        } else if (statusCode === 403) {
          return store.dispatch(refreshUserToken())
        }
        return store.dispatch(handleNetworkError(error.response.status, error.response.data))
      }
      return store.dispatch(handleNetworkError(0))
    })
)

apiPrd.axiosInstance.interceptors.request.use(
  (config) => config,
  (error) => {
    console.log(error)
    return Promise.reject(error)
  }
)
export default apiPrd
